import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ContentEntryDataGetter from 'layers/content/Hocs/ContentEntryDataGetter'
import withApiError from 'layers/errorHandling/apiError/component'
import {
  ERROR_TYPE_CONTENTFUL,
  SHOW_CONTENT_ON_401,
} from 'layers/errorHandling/apiError'
import { actions as siteActions } from 'store/siteManager'
import KickoffModalComponent from './component'

const KickoffModalContainer = ({ clearError, handleClose, modals }) => {
  const closeModal = () => {
    clearError('sitePreferences')
    handleClose()
  }

  if (!modals) return null

  return (
    <KickoffModalComponent
      handleClose={closeModal}
      handleNextButtonClick={closeModal}
      modals={modals}
    />
  )
}

KickoffModalContainer.propTypes = {
  clearError: PropTypes.func,
  handleClose: PropTypes.func,
  modals: PropTypes.array,
}

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = {
  clearError: siteActions.clearError,
}

const mapper = entry => {
  const { modals } = entry || {}

  return {
    modals,
  }
}

const options = {
  entryId: '5QTwWUfk4bOE1IY2hvVZRz',
  include: 3,
  mapper,
  spread: true,
}

export default ContentEntryDataGetter(
  withApiError(
    KickoffModalContainer,
    [ERROR_TYPE_CONTENTFUL],
    [SHOW_CONTENT_ON_401],
  ),
  options,
  connect(mapStateToProps, mapDispatchToProps),
)
